import { render, staticRenderFns } from "./PopupRegistryData.vue?vue&type=template&id=65c8921b"
import script from "./PopupRegistryData.vue?vue&type=script&lang=ts"
export * from "./PopupRegistryData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports